import { RefObject, useEffect, useRef, useState } from 'react';

export default function useOnScreen(
  ref: RefObject<null | HTMLElement>,
  options: IntersectionObserverInit = {},
) {
  const [isOnScreen, setIsOnScreen] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIsOnScreen(entry.isIntersecting);
    }, options);

    observer.observe(element);
    observerRef.current = observer;

    return () => {
      observer.disconnect();
    };
  }, [ref, options]);

  return isOnScreen;
}
